import { defineStore, acceptHMRUpdate } from "pinia";
import Session from "supertokens-web-js/recipe/session";

export const useAuthStore = defineStore("auth", () => {
    const user = ref(null);
    const isConnected = computed(() => !!get(user));
    const roles = ref([]);
    const isAdmin = computed(() => roles.value.includes("Admin"));
    const isInitialized = ref(false);

    async function setUser(session) {
        user.value = session.User;
        roles.value = session["st-role"].v;
    }

    async function clearUser() {
        user.value = null;
        roles.value = [];
        await Session.signOut();
    }

    async function checkAuth() {
        try {
            if (await Session.doesSessionExist()) {
                const session = await Session.getAccessTokenPayloadSecurely();
                await setUser(session);
                useParameters();
                isInitialized.value = true;
                return true;
            }
        } catch (err) {
            console.error("Error checking authentication:", err);
        }
        await clearUser();
        isInitialized.value = true;
        return false;
    }

    return {
        user,
        roles,
        isConnected,
        isAdmin,
        isInitialized,
        setUser,
        clearUser,
        checkAuth,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot));
}
